import isEmpty from "../../validation/isEmpty";
import { types } from "../type";

const initialState = {
  isAuthenticated: false,
  currentUser: {},
  userInfo: null,
  authRegisterUserError: null,
  authResponse: "",
  authError: "",
  authLoading: false,
  authStatus: 0,
  tokenLoading: false,
  token: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AuthTypes.AUTH_SET_LOADING:
      return {
        ...state,
        authLoading: action.payload
      };
    case types.AuthTypes.SET_CURRENT_USER:
      return {
        ...state,
        authLoading: false,
        authError: "",
        currentUser: action.payload,
        isAuthenticated: !isEmpty(action.payload)
      };
    case types.AuthTypes.TOKEN_LOADING:
      return {
        ...state,
        tokenLoading: action.payload
      };
    case types.AuthTypes.TOKEN_FOUND:
      return {
        ...state,
        tokenLoading: false,
        token: action.payload
      };
    case types.AuthTypes.AUTH_CLEAR_ERRORS:
      return {
        ...state,
        authError: ""
      };
    case types.AuthTypes.AUTH_GET_ERRORS:
      return {
        ...state,
        authLoading: false,
        authError: action.payload.data.message,
        authStatus: action.payload.status
      };
    case types.AuthTypes.AUTH_CLEAR_RESULT:
      return {
        ...state,
        authResponse: "",
        authRegisterUserError: null
      };
    case types.AuthTypes.RESET_PASSWORD:
      return {
        ...state,
        authLoading: false,
        authError: "",
        authStatus: 0,
        authResponse: action.payload
      };
    case types.AuthTypes.CHANGE_PASSWORD:
      return {
        ...state,
        authLoading: false,
        authError: "",
        authStatus: 0,
        authResponse: action.payload
      };
    case types.AuthTypes.REGISTER_CSV:
      return {
        ...state,
        authLoading: false,
        authError: "",
        authStatus: 0,
        authResponse: action.payload.message,
        authRegisterUserError: action.payload.errors
      };
    case types.AuthTypes.SEND_OTP:
      return {
        ...state,
        authLoading: false,
        authError: "",
        authStatus: 0,
        authResponse: action.payload.message
      };
    default:
      return state;
  }
};

export default authReducer;
